"use client";

import { useLenis } from "lenis/react";
import { useEffect, useState } from "react";

import { useScrollToTop } from "@/hooks/use-scroll-to-top";

const SHOW_AFTER_SCROLL_PX = 300;

export function ScrollToTopButton() {
  const lenis = useLenis();
  const [visible, setVisible] = useState(false);
  const scrollToTop = useScrollToTop();

  useEffect(() => {
    const threshold = SHOW_AFTER_SCROLL_PX;

    if (lenis) {
      const onScroll = () => {
        setVisible(lenis.scroll > threshold);
      };
      onScroll();
      lenis.on("scroll", onScroll);
      return () => {
        lenis.off("scroll", onScroll);
      };
    }

    const onScroll = () => {
      setVisible(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [lenis]);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-40 flex size-12 cursor-pointer items-center justify-center rounded-full bg-black text-white shadow-lg transition-[transform,opacity,box-shadow] hover:scale-105 hover:shadow-xl focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ff5c00] sm:bottom-8 sm:right-8 sm:size-14"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M12 19V5M12 5L6 11M12 5L18 11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
